import { Layouts } from 'react-grid-layout';
import CustomHoldingsPager from '../../components/Holdings/CustomHoldingsPager';
import SimpleFilters from '../../components/Holdings/SimpleFilters';
import { ViewTicketDetails } from '../../components/Holdings/ViewTicketDetails';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        date: 'today',
        group_by: 'user_asset_class',
    },
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: 'holdings',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'date-picker',
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `portfolio/holdings?`,
                endpointParams: {
                    to_date: '*,date',
                    group_by: 'group_by',
                    group_by_filters: 'group_by_filters',
                },
            },
            props: {
                dataKey: 'holdings',
                requiredQueryFields: ['to_date'],
                clientSideSearch: true,
                clientSideSort: true,
                showDownloadOn: ['desktop'],
                showPagination: false,
                isGroupedData: true,
                CustomTablePager: <CustomHoldingsPager />,
                groupInfo: {
                    groupBy: 'user_asset_class',
                    fieldsToAggregate: [
                        'market_value_base_ccy',
                        'percent_of_assets',
                        'profit_realized_trading_base_ccy',
                        'profit_distributions_base_ccy',
                        'profit_contributions_base_ccy',
                        'profit_total_base_ccy',
                    ],
                    firstKey: 'security_name',
                    noGroupByText: 'All Holdings',
                },
                CustomTableFilter: <SimpleFilters />,
                columns: [
                    {
                        key: 'security_name',
                        type: 'splitCell',
                        expandRow: false,
                        otherKeys: ['ticker'],
                        width: 200,
                        headerText: 'ui.mm.table-headers.name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        actions: [
                            {
                                name: 'ViewSecurity',
                                path: '',
                                Component: <ViewTicketDetails />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        canSort: true,
                        sticky: true,
                    },
                    {
                        key: 'isin',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.isin',
                        canSort: true,
                    },
                    {
                        key: 'parent_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        canSort: true,
                    },
                    {
                        key: 'parent_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                        canSort: false,
                    },
                    {
                        key: 'child_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        canSort: true,
                    },
                    {
                        key: 'child_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                        canSort: true,
                    },
                    {
                        key: 'ccy_account_code',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.ccy-account-code',
                        canSort: false,
                    },
                    {
                        key: 'user_asset_class',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.asset-class',
                        canGroupBy: true,
                        canSort: true,
                    },
                    {
                        key: 'user_industry',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.sub-asset-class',
                        canSort: true,
                    },
                    {
                        key: 'user_geography',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.geography',
                        canSort: true,
                    },
                    {
                        key: 'custodian_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.custodian-name',
                        canSort: true,
                    },
                    {
                        key: 'contract_currency',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.ccy',
                        selectedByDefaultOn: ['desktop'],
                        canSort: true,
                    },
                    {
                        key: 'display_quantity',
                        type: 'amount',
                        width: 130,
                        headerText: 'ui.mm.table-headers.qty',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'average_price',
                        type: 'amount',
                        width: 130,
                        headerText: 'ui.mm.table-headers.average-price',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'contract_fx',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.contract_fx',
                        canSort: false,
                    },
                    {
                        key: 'basefx_rate',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.basefx_rate',
                        canSort: false,
                    },

                    {
                        key: 'latest_price_close',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.latest_price_close',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'latest_price_date',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.latest_price_date',
                        canSort: false,
                    },
                    {
                        key: 'profit_realized_trading_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.realized-trading-profit',
                        canSort: true,
                        width: 130,
                    },
                    {
                        key: 'profit_realized_trading_base_ccy',
                        type: 'amount',
                        width: 130,
                        headerText:
                            'ui.mm.table-headers.realized_profit_trading_base_ccy',
                        canSort: true,
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                    },
                    {
                        key: 'profit_distributions_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.distribution',
                        canSort: true,
                        width: 130,
                    },
                    {
                        key: 'profit_distributions_base_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.realized_profit_distribution_base_ccy',
                        canSort: true,
                        width: 130,
                        selectedByDefaultOn: ['desktop'],
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                    },
                    {
                        key: 'profit_contributions_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.profit_contributions_ccy',
                        canSort: true,
                        width: 130,
                    },
                    {
                        key: 'profit_contributions_base_ccy',
                        type: 'amount',
                        width: 130,
                        headerText:
                            'ui.mm.table-headers.profit-contributions_base_ccy',
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                        canSort: true,
                    },
                    {
                        key: 'profit_unrealized_ccy',
                        type: 'amount',
                        width: 130,
                        headerText: 'ui.mm.table-headers.unrealized-profit',
                        canSort: true,
                    },
                    {
                        key: 'profit_unrealized_base_ccy',
                        type: 'amount',
                        width: 130,
                        headerText:
                            'ui.mm.table-headers.unrealized-profit-base-ccy',
                        selectedByDefaultOn: ['desktop'],
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                        canSort: true,
                    },
                    {
                        key: 'profit_total_ccy',
                        type: 'amount',
                        width: 130,
                        headerText: 'ui.mm.table-headers.total-profit',
                        canSort: true,
                    },
                    {
                        key: 'profit_total_base_ccy',
                        type: 'amount',
                        width: 130,
                        headerText: 'ui.mm.table-headers.total_profit_base_ccy',
                        selectedByDefaultOn: ['desktop'],
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                        canSort: true,
                    },
                    {
                        key: 'percent_of_assets',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.percentage-of-total',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'market_value_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.market_value_ccy',
                        canSort: true,
                        width: 130,
                    },
                    {
                        key: 'market_value_base_ccy',
                        type: 'amount',
                        otherKeys: ['base_ccy'],
                        width: 200,
                        headerText: 'ui.mm.table-headers.market-value',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_ccy',
                            },
                        ],
                        canSort: true,
                    },
                ],
                ga_event_name: 'Review All Holdings ',
            },
        },
    ],
};
